import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { PlaylistId } from 'types/playlist'
import type { State } from 'types/redux'
import type { Track } from 'types/track'
import { getShortlistTempItem } from '@disco/state-management/selectors/shortlists'
import ShortlistTrack from 'components/shortlist/track'
type Props = {
  index: number
  itemIndex: number
  sourcePlaylistId: PlaylistId | null | undefined
  sourceShortlistId: string
  tempId: string
}

const ShortlistTempItem = ({
  index,
  itemIndex,
  sourcePlaylistId,
  sourceShortlistId,
  tempId,
}: Props) => {
  const item = useSelector((state: State) =>
    getShortlistTempItem(state, {
      id: sourceShortlistId,
      tempItemId: tempId,
    }),
  )

  if (!item) {
    return null
  }

  return (
    <ShortlistTrack
      index={index}
      itemIndex={itemIndex}
      sourcePlaylistId={sourcePlaylistId}
      sourceShortlistId={sourceShortlistId}
      // @ts-expect-error
      track={{ ...item, groups: [] }}
    />
  )
}

export default React.memo<Props>(ShortlistTempItem)
